import {observable, runInAction} from 'mobx'
import moment from "moment";
import {fetchWithCsrf} from "../../src/utils/csrf";

// kix-gbc Web用のAPIパス（セッション認証）
const KIX_GBC_API_PATH = "/api/kix_gbc";

export class TimeStore {
  @observable
  public time:any;

  getCurrentTime = () => {
    fetchWithCsrf(KIX_GBC_API_PATH + "/get_current_time", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({}),
      credentials: "include"
    }).then(async (res: any) => {
      const data = await res.json();
      runInAction(() => {
        this.time = moment(data.value);
      });
    });
  }
}

export const timeStore = new TimeStore();


